define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/Controller",
    "csi/comm/PostRequest",
    "csi/xml",
], function(declare,lang,Controller,PostRequest,xml) {

return declare(Controller, {

        process: function() {
            // summary: issue request so as to be able to receive return value
            var req = this.m_action.m_request;
            var fd = this.getFormData();
            var results = fd.getSelectedNodes().map(n=>n.$URL);
            this.setProgress();

            const request = new PostRequest(req.m_module, req.m_operation)
                .addParameter("ParentURL",this.m_urlParent)
                .addParameter("ContextColorwaysToClear", results);

            this.waitForPublish(request.post(), true);
        },

    });
});